import {default as WithAuthWeb} from './with_oauth_web';
import {default as WithAuthMobile} from './with_oauth_mobile';

export default process.env.MOBILE ? WithAuthMobile : WithAuthWeb;
